module.exports = __webpack_public_path__ + "static/media/ppsx.7335e621.svg";